export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {},
  vueI18nLoader: false,
  locales: [{"code":"en","file":"en.json"},{"code":"pt","file":"ao.json"},{"code":"es","file":"es.json"},{"code":"fr","file":"fr.json"}],
  defaultLocale: "pt",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "lang/",
  rootRedirect: null,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: false,
  pages: {"testimonial/index":{"en":"/testimonials","pt":"/testemunhos","es":"/testimonios","fr":"/temoignages"},"testimonial/_slug":{"en":"/testimonials/:slug","pt":"/testemunhos/:slug","es":"/testimonios/:slug","fr":"/temoignages/:slug"},"recipe/index":{"en":"/recipes","pt":"/receitas","es":"/recetas","fr":"/recettes"},"recipe/_slug":{"en":"/recipes/:slug","pt":"/receitas/:slug","es":"/recetas/:slug","fr":"/recettes/:slug"},"recipe/cat/_slug":{"en":"/recipes/category/:slug","pt":"/receitas/categoria/:slug","es":"/recetas/categoria/:slug","fr":"/recettes/categorie/:slug"},"clinic/index":{"en":"/lev-clinics","pt":"/clinicas-lev","es":"/centros-lev","fr":"/centre-lev-diet"},"clinic/_slug":{"en":"/lev-clinics/:slug","pt":"/clinicas-lev/:slug","es":"/centros-lev/:slug","fr":"/centre-lev-diet/:slug"},"blog/index":{"en":"/nutrition","pt":"/nutricao","es":"/nutricion","fr":"/nutrition"},"shop":{"en":"/shop","pt":"/loja-online","es":"/tienda","fr":"/boutique"},"category/_slug":{"en":"/nutrition-category/:slug","pt":"/nutricao-categoria/:slug","es":"/nutricion-categoria/:slug","fr":"/categorie/:slug"},"product/_slug":{"en":"/product/:slug","pt":"/produto/:slug","es":"/producto/:slug","fr":"/produit/:slug"},"product-category/_slug":{"en":"/product-category/:slug","pt":"/categoria-produto/:slug","es":"/categoria-producto/:slug","fr":"/categorie-produit/:slug"},"product-tag/_slug":{"en":"/product-tag/:slug","pt":"/etiqueta-produto/:slug","es":"/etiqueta-producto/:slug","fr":"/etiquette-produit/:slug"},"my-products":{"en":"/my-products","pt":"/meus-produtos","es":"/mis-productos","fr":"/mes-produits"},"my-favorites":{"en":"/my-favorites","pt":"/meus-favoritos","es":"/mis-favoritos","fr":"/mes-favoris"},"my-watchlist":{"en":"/my-watchlist","pt":"/minha-lista-de-observacao","es":"/mi-lista-de-seguimiento","fr":"/ma-liste-de-surveillance"},"my-page":{"en":"/my-page","pt":"/minha-pagina","es":"/mi-pagina","fr":"/ma-page"},"results":{"en":"/results","pt":"/resultados-pesquisa","es":"/resultados-busqueda","fr":"/resultats"}},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  fallbackLocale: "pt",
  normalizedLocales: [{"code":"en","file":"en.json"},{"code":"pt","file":"ao.json"},{"code":"es","file":"es.json"},{"code":"fr","file":"fr.json"}],
  localeCodes: ["en","pt","es","fr"],
  additionalMessages: [],
}
export const localeFiles = {
  0: "{",
  1: "\"",
  2: "e",
  3: "n",
  4: ".",
  5: "j",
  6: "s",
  7: "o",
  8: "n",
  9: "\"",
  10: ":",
  11: "\"",
  12: ".",
  13: ".",
  14: "/",
  15: "l",
  16: "a",
  17: "n",
  18: "g",
  19: "/",
  20: "e",
  21: "n",
  22: ".",
  23: "j",
  24: "s",
  25: "o",
  26: "n",
  27: "\"",
  28: ",",
  29: "\"",
  30: "a",
  31: "o",
  32: ".",
  33: "j",
  34: "s",
  35: "o",
  36: "n",
  37: "\"",
  38: ":",
  39: "\"",
  40: ".",
  41: ".",
  42: "/",
  43: "l",
  44: "a",
  45: "n",
  46: "g",
  47: "/",
  48: "a",
  49: "o",
  50: ".",
  51: "j",
  52: "s",
  53: "o",
  54: "n",
  55: "\"",
  56: ",",
  57: "\"",
  58: "e",
  59: "s",
  60: ".",
  61: "j",
  62: "s",
  63: "o",
  64: "n",
  65: "\"",
  66: ":",
  67: "\"",
  68: ".",
  69: ".",
  70: "/",
  71: "l",
  72: "a",
  73: "n",
  74: "g",
  75: "/",
  76: "e",
  77: "s",
  78: ".",
  79: "j",
  80: "s",
  81: "o",
  82: "n",
  83: "\"",
  84: ",",
  85: "\"",
  86: "f",
  87: "r",
  88: ".",
  89: "j",
  90: "s",
  91: "o",
  92: "n",
  93: "\"",
  94: ":",
  95: "\"",
  96: ".",
  97: ".",
  98: "/",
  99: "l",
  100: "a",
  101: "n",
  102: "g",
  103: "/",
  104: "f",
  105: "r",
  106: ".",
  107: "j",
  108: "s",
  109: "o",
  110: "n",
  111: "\"",
  112: "}",
}

export const localeMessages = {
  'en.json': () => import('../../lang/en.json' /* webpackChunkName: "lang-en.json" */),
  'ao.json': () => import('../../lang/ao.json' /* webpackChunkName: "lang-ao.json" */),
  'es.json': () => import('../../lang/es.json' /* webpackChunkName: "lang-es.json" */),
  'fr.json': () => import('../../lang/fr.json' /* webpackChunkName: "lang-fr.json" */),
}
